import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import { useCoreInput } from "@Shared/@Composables/inputs/useCoreInput";
import { defineComponent, onMounted, ref, toRefs } from "@vue/composition-api";
import { v4 as uuidv4 } from "uuid";
export default defineComponent({
  name: "BaseCheckbox",
  props: {
    value: {
      type: null,
      default: null
    },
    optionValue: {
      type: null,
      default: null
    },
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      default: ""
    },
    inputColor: {
      type: String,
      default: "primary-o"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    browserAutocomplete: {
      type: Boolean,
      default: false
    },
    inputType: {
      type: String,
      default: "checkbox",
      validator: value => {
        var _context;
        return _includesInstanceProperty(_context = ["checkbox", "radio"]).call(_context, value);
      }
    },
    label: {
      type: String,
      default: ""
    },
    hasTooltip: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String,
      default: ""
    }
  },
  setup(props) {
    const {
      value
    } = toRefs(props);
    const labelValue = uuidv4();
    onMounted(() => {
      $(".pretty input").attr("id", `${labelValue}`);
    });
    const {
      handleBaseFocus,
      handleBaseBlur,
      handleBaseChange,
      handleBaseInput,
      valueModel
    } = useCoreInput({
      value
    });
    const inputRef = ref();
    const focus = () => {
      var _inputRef$value;
      inputRef == null ? void 0 : (_inputRef$value = inputRef.value) == null ? void 0 : _inputRef$value.focus();
    };
    const blur = () => {
      var _inputRef$value2;
      inputRef == null ? void 0 : (_inputRef$value2 = inputRef.value) == null ? void 0 : _inputRef$value2.blur();
    };
    return {
      inputRef,
      valueModel,
      labelValue,
      handleBaseFocus,
      handleBaseBlur,
      handleBaseChange,
      handleBaseInput,
      focus,
      blur
    };
  }
});